import FigmaBox from '../../../mynt-components/components/FigmaBox'
import { usePisDeposits } from '../api/usePisDeposits'
import { PisDepositStatusLegend } from './PisDepositStatusLegend'
import { PisDepositsTable } from './PisDepositsTable'

type CustomerPisDepositsTabProps = {
  customerId: string
}

export const CustomerPisDepositsTab = ({ customerId }: CustomerPisDepositsTabProps) => {
  const { data: deposits = [], isFetching } = usePisDeposits(customerId)

  return (
    <FigmaBox fullWidth gap="16px">
      <PisDepositStatusLegend />
      <PisDepositsTable customerId={customerId} deposits={deposits} isLoading={isFetching} />
    </FigmaBox>
  )
}
